import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { SummaryAPI } from '@business/api/summary';
import { SummaryGraphResponse, SummaryResponse } from '@business/entities/summary';

export class SummaryBloc extends BaseBloc {
  private readonly summaryRepo = new Repository<SummaryGraphResponse>({
    getItemId: item => item.id,
  });

  readonly groupGraphs$ = this.summaryRepo.items$;
  readonly groupGraphs = this.summaryRepo.items;
  readonly selectGroupGraph = this.summaryRepo.selectItem;

  onReset() {
    this.summaryRepo.reset();
  }

  fetchGroupGraphs = (params: SummaryResponse) => {
    return SummaryAPI.fetchGroupGraphs(params).pipe(handleMessage({ error: requestMessage('fetch_summary_error') }));
  };

  updateGraphSummaryValues = (params: SummaryResponse) => {
    return SummaryAPI.updateGraphSummaryValues(params).pipe(
      this.summaryRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_summary_error'),
      }),
    );
  };

  updateSpreadsheetValues = (params: any) => {
    return SummaryAPI.updateSpreadsheetValues(params).pipe(
      this.summaryRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_summary_error'),
      }),
    );
  };
}
